/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Data_Title4Inputs */

const en_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data sourcing`)
};

const ar_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توفير البيانات`)
};

const bn_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটা সংগ্রহ`)
};

const de_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbeschaffung`)
};

const es_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtención de datos`)
};

const fr_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecte de données`)
};

const pt_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenção de dados`)
};

const zh_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据采集`)
};

const tr_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri tedariği`)
};

const ru_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добыча данных`)
};

const pl_svc_programmatic_seo_data_title4 = /** @type {(inputs: Svc_Programmatic_Seo_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozyskiwanie danych`)
};

/**
* | output |
* | --- |
* | "Data sourcing" |
*
* @param {Svc_Programmatic_Seo_Data_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_data_title4 = /** @type {((inputs?: Svc_Programmatic_Seo_Data_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Data_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_data_title4(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_data_title4(inputs)
	if (locale === "de") return de_svc_programmatic_seo_data_title4(inputs)
	if (locale === "es") return es_svc_programmatic_seo_data_title4(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_data_title4(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_data_title4(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_data_title4(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_data_title4(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_data_title4(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_data_title4(inputs)
	return en_svc_programmatic_seo_data_title4(inputs)
});
export { svc_programmatic_seo_data_title4 as "svc_programmatic-seo_DATA_title" }